import { render, staticRenderFns } from "./CompetitionRegister.vue?vue&type=template&id=53141b43&"
import script from "./CompetitionRegister.vue?vue&type=script&lang=js&"
export * from "./CompetitionRegister.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports